import { TrackResource } from '@/models'
import { TRACKS_FAILURE, TRACKS_REQUEST, TRACKS_SUCCESS } from '@/redux/actionTypes'

export interface TracksState {
    tracks: TrackResource[]
    loading: boolean
    errors: unknown[]
}

export type TracksAction =
    | { type: typeof TRACKS_REQUEST }
    | { type: typeof TRACKS_SUCCESS, tracks: TrackResource[] }
    | { type: typeof TRACKS_FAILURE, errors: unknown[] }

const initialState: TracksState = {
    tracks: [],
    loading: false,
    errors: [],
}

export const tracksReducer = (state: TracksState = initialState, action: TracksAction): TracksState => {
    switch (action.type) {
        case TRACKS_REQUEST:
            return { ...state, loading: true }
        case TRACKS_SUCCESS:
            return {
                ...state, loading: false, tracks: action.tracks,
            }
        case TRACKS_FAILURE:
            return {
                ...state, loading: false, errors: action.errors,
            }
        default:
            return state
    }
}
